import { createFileRoute, redirect } from "@tanstack/react-router";

// Fundraising Settings moved to /fundraising-settings (under the Settings
// tab bar) as part of the Your Donors nav refactor. Keep this route as a
// permanent redirect so existing deep links and bookmarks don't 404.
export const Route = createFileRoute("/_app/_/fundraising/settings")({
	beforeLoad: () => {
		throw redirect({
			to: "/fundraising-settings",
			search: { section: "integrations" },
		});
	},
});
